import { ConfigurationService } from './configuration.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(
    private configService: ConfigurationService,
    private httpClient: HttpClient
  ) { }

  downloadFile(containerName: string, siteId: string, fileId: string): Observable<any> {
    const downloadUrl = `${this.getFileStorageBaseUrl()}/files/${containerName}/${siteId}/${fileId}`;
    return this.httpClient.get(downloadUrl, { responseType: 'arraybuffer' });
  }

  getFileList(containerName: string, siteId: string): Observable<any> {
    return this.httpClient.get<any>(`${this.getFileStorageBaseUrl()}files/${containerName}/${siteId}`);
  }

  getNotesFileUploadUrl(siteRef: string, fileName: string): Observable<any> {
    // Request the notes-service upload metadata for a generated PDF filename.
    const uploadUrl = `${this.getNotesBaseUrl()}notes-files/v2/uploadUrl?siteRef=${encodeURIComponent(siteRef)}`;

    return this.httpClient.post(uploadUrl, fileName, {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain'
      })
    });
  }

  getFileStorageBaseUrl() {
    let region = this.configService.getSelectedRegion();
    return this.configService.getConfig(region).filestorageUrl;
  }

  getNotesBaseUrl() {
    let region = this.configService.getSelectedRegion();
    const notesUrl = this.configService.getConfig(region).notesUrl;
    return notesUrl.endsWith('/') ? notesUrl : `${notesUrl}/`;
  }

}
